'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

require('../styles/EmbeddedChatWidget.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmbeddedChatWidget = function (_BcReactComponent) {
  _inherits(EmbeddedChatWidget, _BcReactComponent);

  function EmbeddedChatWidget() {
    _classCallCheck(this, EmbeddedChatWidget);

    return _possibleConstructorReturn(this, (EmbeddedChatWidget.__proto__ || Object.getPrototypeOf(EmbeddedChatWidget)).apply(this, arguments));
  }

  _createClass(EmbeddedChatWidget, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          widget = _props.widget,
          classes = _props.classes;

      var iframeSrc = '/widgets/chat_widget/' + widget;

      return _react2.default.createElement(
        'div',
        { className: 'cp-embedded-chat-widget ' + widget + '-widget ' + (classes || '') },
        _react2.default.createElement('iframe', { src: iframeSrc })
      );
    }
  }]);

  return EmbeddedChatWidget;
}(_baseBcReactComponent2.default);

EmbeddedChatWidget.propTypes = {
  widget: _react.PropTypes.string.isRequired,
  classes: _react.PropTypes.string
};

exports.default = EmbeddedChatWidget;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-embedded-chat-widget/lib/components/EmbeddedChatWidget.component.js
// module id = 1480
// module chunks = 1